module.exports = __webpack_public_path__ + "static/media/pytorch.7eeaeef4.svg";